import { CompareFinancingTypes } from './CompareFinancingTypes';
import { CompareValuesPerYearPerMonth } from './CompareValuesPerYearPerMonth';
import { CompareValuesPerYearPerMonthPercentage } from './CompareValuesPerYearPerMonthPercentage';

export const CompareCharts = () => {
    return (
        <>
            <CompareValuesPerYearPerMonth />
            <CompareValuesPerYearPerMonthPercentage />
            <CompareFinancingTypes />
        </>
    );
};
